var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#c22929",
    height: "20px",
    width: "20px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    stroke: "var(--error)",
    strokeWidth: 0.00512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M255.967,384c-17.643,0-32,14.357-32,32c0,17.643,14.357,32,32,32s32-14.357,32-32 C287.967,398.357,273.61,384,255.967,384z M255.967,426.667c-5.888,0-10.667-4.8-10.667-10.667 c0-5.867,4.779-10.667,10.667-10.667c5.888,0,10.667,4.8,10.667,10.667C266.634,421.867,261.855,426.667,255.967,426.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.823,402.368L321.524,38.912C308.234,14.549,283.722,0,255.967,0S203.7,14.549,190.026,39.723L30.303,401.984 c-12.523,23.275-11.947,50.709,1.557,73.472C45.45,498.325,69.45,512,96.074,512h319.808c26.603,0,50.624-13.675,64.192-36.544 C493.663,452.565,494.175,424.939,481.823,402.368z M461.727,464.576c-9.707,16.363-26.859,26.112-45.867,26.112H96.052 c-19.008,0-36.16-9.749-45.867-26.112c-9.707-16.363-10.069-36.096-0.96-52.779c0.149-0.256,0.277-0.512,0.405-0.789 L209.14,49.131c9.493-17.408,27.008-27.797,46.827-27.797s37.333,10.389,46.421,27.008l160.299,363.456 C471.796,428.501,471.434,448.213,461.727,464.576z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.57,141.035c-7.509,8.299-11.157,19.413-10.048,30.528l18.155,181.504c0.555,5.461,5.141,9.6,10.624,9.6h21.333 c5.483,0,10.069-4.139,10.603-9.6l18.155-181.504c1.109-11.115-2.539-22.229-10.048-30.528 C270.346,124.459,241.567,124.459,226.57,141.035z M274.186,169.429l-17.195,171.904h-2.027l-17.152-171.904 c-0.533-5.205,1.109-10.197,4.629-14.08c7.019-7.744,20.096-7.744,27.115,0C273.055,159.211,274.698,164.224,274.186,169.429z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.9bda85957276eec95099c877c9743100.svg";
export { ForwardRef as ReactComponent };